/**
 * Copyright (c) Stanislav Shishankin
 *
 * This source code is licensed under the MIT license.
 */
//let {Event} = require('../Event');

class LinkToView{// extends Event{
    addEvents(){}
    clearEvents(){}

    linkView(view){
        this.view = view;
    }

    constructor(){
        this.view = null;
    }
}

class LinkToViewElement extends LinkToView{
    addEventsToEL(el, view){}

    addEvents(){
        for (let el of this.elements){
            this.addEventsToEL(el, this.view);
        }
    }
    
    clearEvents(){}

    linkElements(view, selector){}

    linkView(view){
        this.view = view;
        this.elements = view.findAll(this.selector);

        this.linkElements(view, this.selector);
    }

    constructor(selector){
        super();
        this.elements = null;
        this.selector = selector;
    }
}

class LinkToElement{//} extends Event{
    addEventsToEL(el, view){}

    addEvents(view){
        for (let el of this.elements){
            this.addEventsToEL(el, view);
        }
    }
    
    clearEvents(){}

    initSelector(view, selector){}

    linkElements(view, selector){
        this.view = view;
        this.elements = view.findAll(selector);
        this.selector = selector;

        this.initSelector(view, selector);
    }

    constructor(){
        this.view = null;
        this.elements = null;
        this.selector = null;
    }
}

module.exports = {LinkToView, LinkToViewElement, LinkToElement};